import { Text } from '@bpba/ui-components';
import { FC, ReactNode } from 'react';
import styled from 'styled-components';
import { TextLink } from '../shared/TextLink';
import { ModuleContainerGeneric } from '@bpba/modules-components';
import { MarginProps, margin, BorderProps, border, ColorProps, color, TypographyProps, typography } from 'styled-system';

type Props = {
  title: string;
  description: string;
};

export const GenericError: FC<Props> = ({ title, description }) => {
  const homeUrl = process.env.PUBLIC_URL ? process.env.PUBLIC_URL : '/';

  return (
    <ModuleContainerGeneric marginTop={[16, 0]}>
      <Title
        color={'primary.0'}
        marginTop="12px"
        marginBottom="7px"
        fontWeight={400}
        fontSize={['26px', null, '34px', '36px']}
        lineHeight={['32px', null, '41px', '43px']}
        tabIndex={0}
      >
        {title}
      </Title>
      <Divider marginBottom="12px" marginTop="12px" borderBottomColor={'primary.0'} borderBottomStyle="solid" borderBottomWidth="1px" />

      <ContentContainer tabIndex={0}>
        <StyledParagraph>{description}</StyledParagraph>
        <StyledParagraph>Muchas gracias y disculpe las molestias ocasionadas.</StyledParagraph>
      </ContentContainer>

      <br />

      <StyledParagraph>
        <TextLink href={homeUrl}>Volver a la página inicial</TextLink>
      </StyledParagraph>
    </ModuleContainerGeneric>
  );
};

type TitleProps = ColorProps & MarginProps & TypographyProps;
const Title = styled.h1<TitleProps>(color, margin, typography, { width: 'fit-content' });

type DividerProps = MarginProps & BorderProps;
const Divider = styled.div<DividerProps>(margin, border);

const ContentContainer = styled.div({
  width: 'fit-content',
});

type StyledParagraphProps = {
  children: ReactNode;
};
const StyledParagraph: FC<StyledParagraphProps> = ({ children }) => {
  return (
    <Text fontSize={[14, null, 16]} lineHeight={['18px', null, '21px']}>
      {children}
    </Text>
  );
};
